var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupedColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 41,
    viewBox: "0 0 57 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5108 40.5029H3.98828V16.6956C3.98828 16.513 4.16527 16.365 4.38359 16.365H10.1155C10.3338 16.365 10.5108 16.513 10.5108 16.6956V40.5029Z",
    fill: "#003F7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0738 40.5029H11.5513V9.10418C11.5513 8.92448 11.7283 8.77881 11.9466 8.77881H17.6785C17.8968 8.77881 18.0738 8.92448 18.0738 9.10418V40.5029Z",
    fill: "#0069D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6367 40.5029H19.1141V0.830798C19.1141 0.649721 19.2911 0.50293 19.5094 0.50293H25.2414C25.4597 0.50293 25.6367 0.649721 25.6367 0.830798V40.5029Z",
    fill: "#0298A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1593 40.5028H31.6367V24.9645C31.6367 24.7857 31.8137 24.6407 32.032 24.6407H37.764C37.9823 24.6407 38.1593 24.7857 38.1593 24.9645V40.5028Z",
    fill: "#003F7F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7223 40.5028H39.1997V19.4524C39.1997 19.2708 39.3767 19.1235 39.595 19.1235H45.3269C45.5453 19.1235 45.7223 19.2708 45.7223 19.4524V40.5028Z",
    fill: "#0069D1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2851 40.5027H46.7626V13.9362C46.7626 13.754 46.9396 13.6062 47.1579 13.6062H52.8898C53.1081 13.6062 53.2851 13.754 53.2851 13.9362V40.5027Z",
    fill: "#0298A6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.988281 40.5043L56.9883 40.5043",
    stroke: "#2B2B35",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupedColumn);
export default __webpack_public_path__ + "static/media/grouped_column.731c72059fb038ad0b208a3463ffe45c.svg";
export { ForwardRef as ReactComponent };